(() => {
  const initialize = () => {
    const form = document.querySelector('product-form[data-handle="diamond-eternity-wedding-ring-band-14k-white-gold-0-51ctw"]');
    const size = form?.querySelector('select[name="properties[_size]"]');
    const selector = form?.querySelector('variant-selector');
    if (!size || !selector || size.dataset.inventoryLinked === 'true') return;
    size.dataset.inventoryLinked = 'true';

    const synchronize = () => {
      const selectedSize = size.value.split(':')[0].trim();
      if (!selectedSize) return;
      const option = Array.from(selector.querySelectorAll('option[data-option-size]'))
        .find(option => option.dataset.optionSize === selectedSize);
      if (option && typeof selector.update === 'function') selector.update(option.value);
    };

    size.addEventListener('change', synchronize);
    selector.addEventListener('ready', synchronize);
    synchronize();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
